import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, PieSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_FUNNEL_FORM_DATA,
    EchartsDoughnutChartProps,
    EchartsDoughnutFormData,
    DoughnutChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
import { getLegendObject } from '../../utils';
  
export default function transformProps(
    chartProps: EchartsDoughnutChartProps,
): DoughnutChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      tooltipFormat,
      showLegend,
      legendOrientation,
      legendMargin
    }: EchartsDoughnutFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_FUNNEL_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel)
      : [groupby].map(getColumnLabel);

    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    const seriesData = data.map(datum => {
      const label = extractGroupbyLabel({
        datum,
        groupby: groupbyLabels,
        coltypeMapping: {},
      });
      return {
        name: label,
        value: datum[metricLabel]
      };
    });
  
    const series: PieSeriesOption[] = [
      {
        name: metricLabel,
        type: 'pie',
        radius: ['40%', '70%'],
        animation: true,
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 40,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      tooltip: {
        trigger: 'item',
        formatter: tooltipFormat,
      },
      legend: {...getLegendObject(showLegend, legendOrientation,
        legendMargin ? legendMargin.toString() : undefined)},
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  